import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import fetchInspirationArticles from '../../../redux/actions/inspirationArticles';
import fetchStyles from '../../../redux/actions/styles';
import { getArrayInspirationArticles, getArrayStyles } from '../../../redux/selectors/pages';

import { errorLogger } from '@/utils';

import Image from '../../../components/ContentfulImage';
import { TABLET_L } from '../../../constants';

import {
  Title,
  TagSection,
  TagSectionTitle,
  TagList,
  Tag,
  MoreTag,
  Wrapper,
  Contents,
  ItemList,
  Item,
  ItemMb,
  ItemContents,
  ItemTitle,
  ItemTitleMb,
  ItemDescription,
  MoreButton,
} from './PastArticles.style';



const itemSize = 6;
const tagListMhMb = 171;
const tagListMhPc = 106;

class PastArticles extends Component {
  state = {
    needMoreTag: false,
    moreTag: false,
    showItems: 6,
    selectedTags: [],
  };

  componentWillMount() {
    const { fetchInspirationArticles, fetchStyles, locale, isBTC } = this.props;
    if (isBTC) {
      fetchInspirationArticles({ locale })
        .then(res => res)
        .catch(e => {
          errorLogger(e);
        });
    } else {
      fetchStyles({ locale })
      .then(res => res)
      .catch(e => {
        errorLogger(e);
      });
    }
  }

  componentDidUpdate() {
    this.setNeedMoreTag();
  }

  setNeedMoreTag = () => {
    if (this.tagListElementHeight) {
      return;
    }
    const maxHeight = this.props.screenSize < TABLET_L ? tagListMhMb : tagListMhPc;
    const tagListElement = document.getElementById('tagList') || {};
    this.tagListElementHeight = tagListElement.clientHeight;

    if (this.tagListElementHeight > maxHeight) {
      this.setState({ needMoreTag: true });
    }
  }

  onClickMore = () => {
    this.setState(prev => ({ showItems: prev.showItems + itemSize }));
  }

  onClickMoreTag = () => {
    this.setState(prev => ({ moreTag: !prev.moreTag }));
  }

  onClickTag = tag => () => {
    this.setState(prev =>
      ({ selectedTags: prev.selectedTags.includes(tag) ? prev.selectedTags.filter(t => t !== tag) : [tag, ...prev.selectedTags]}));
  }

  render() {
    const { articles, copy, styles, screenSize, locale, isBTC } = this.props;
    const { needMoreTag, moreTag, showItems, selectedTags } = this.state;
    const items = isBTC ?
      articles.map(a => { a.images = a.btcThumbnail ? [a.btcThumbnail] : null; a.description = a.btcShortDescription; return a; }) :
      styles.map(s => { s.title = s.name; return s; });
    const allTags = [...new Set(items.reduce((acc, v) => (isBTC ? acc.concat(v.btcTags) : acc.concat(v.caCategories)), []).filter(t => t).map(t => t.title))];
    const filterdItems = items.filter(item => {
      if (!selectedTags.length) return true;
      if (isBTC) {
        return item.btcTags && item.btcTags.some(t => selectedTags.includes(t.title));
      }
      return item.caCategories && item.caCategories.some(t => selectedTags.includes(t.title));
    });


    const getLink = item => isBTC ? `/${locale}/inspiration/beauty-creators-talk/${item.slug}` : `/${locale}/style/${item.slug}`;

    return (
      <Wrapper>
        <Contents>
          <Title>{copy.past_articles}</Title>
          {!!items.length &&
            <TagSection>
              <TagSectionTitle>{copy.find_by_tags}</TagSectionTitle>
              <TagList opened={moreTag} maxHeight={[tagListMhMb, tagListMhPc]}>
                <div id="tagList">
                  {allTags.map(tag => <Tag selected={selectedTags.includes(tag)} onClick={this.onClickTag(tag)}>{tag}</Tag>)}
                </div>
              </TagList>
              {needMoreTag && <MoreTag opened={moreTag}><span onClick={this.onClickMoreTag}>{copy.show_more_tags}</span></MoreTag>}
            </TagSection>
          }
          <ItemList>
            {!items.length && [... new Array(3)].map(() => (
              <React.Fragment>
              {screenSize < TABLET_L ? (
                <ItemMb />
                ) : (
                <Item />
              )}
              </React.Fragment>
            ))}
            {filterdItems.slice(0, showItems).map(item => (
              <React.Fragment>
              {screenSize < TABLET_L ? (
                <ItemMb>
                  <Link to={getLink(item)} href={getLink(item)}>
                    {item.images ? <Image src={item.images[0]} options={{ h: '71px', w: '120px', objectFit: 'cover', objectPosition: 'left center' }} /> : <div style={{ height: '200px', width: '100%' }} />}
                    <ItemTitleMb>{item.title}</ItemTitleMb>
                  </Link>
                </ItemMb>
                ) : (
                <Item>
                  <Link to={getLink(item)} href={getLink(item)}>
                    {item.images ? <Image src={item.images[0]} options={{ h: '200px', w: '100%', objectFit: 'cover', objectPosition: 'left center' }} /> : <div style={{ height: '200px', width: '100%' }} />}
                    <ItemContents>
                      <ItemTitle>{item.title}</ItemTitle>
                      <ItemDescription>{item.description}</ItemDescription>
                    </ItemContents>
                  </Link>
                </Item>
              )}
              </React.Fragment>
            ))}
          </ItemList>
          {showItems < filterdItems.length && <MoreButton onClick={this.onClickMore}>{copy.view_more}</MoreButton>}
        </Contents>
      </Wrapper>
    );
  }
}

PastArticles.defaultProps = {
  articles: [],
  styles: [],
  copy: {},
  season: undefined,
  isBTC: true,
};

PastArticles.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  screenSize: PropTypes.number.isRequired,
  isBTC: PropTypes.bool,
  articles: PropTypes.arrayOf(PropTypes.shape()),
  styles: PropTypes.arrayOf(PropTypes.shape()),
  fetchInspirationArticles: PropTypes.func.isRequired,
  fetchStyles: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapState = (state, props) => ({
  locale: state.locale,
  articles: getArrayInspirationArticles(state, { ...props, dataLevel: 2 }),
  styles: getArrayStyles(state, { ...props, dataLevel: 2 }),
});

const mapDispatch = dispatch => ({
  fetchInspirationArticles: params => dispatch(fetchInspirationArticles(params)),
  fetchStyles: params => dispatch(fetchStyles(params)),
});

export default connect(mapState, mapDispatch)(PastArticles);



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/PastArticles/PastArticles.js